var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(0.471 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Notification_Icon",
    "data-name": "Notification Icon",
    d: "M7.875,18.375h5.25a2.625,2.625,0,0,1-5.25,0ZM1.312,17.063a1.312,1.312,0,1,1,0-2.625h.657A5.714,5.714,0,0,0,3.937,10.5V6.563A6.5,6.5,0,0,1,10.5,0a6.5,6.5,0,0,1,6.562,6.563V10.5a5.711,5.711,0,0,0,1.969,3.938h.657a1.312,1.312,0,1,1,0,2.625Z",
    transform: "translate(-0.471 7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Notification_Badge",
    "data-name": "Notification Badge",
    transform: "translate(14.529)",
    fill: "#ee7404",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 6.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f46fd41aa314c47004e278de00bf035d.svg";
export { ForwardRef as ReactComponent };